var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 18,
    viewBox: "0 0 117 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.599 9.30328C116.042 8.97402 116.135 8.34765 115.805 7.90425L110.44 0.678608C110.11 0.235207 109.484 0.14268 109.041 0.471942C108.597 0.801205 108.505 1.42757 108.834 1.87097L113.603 8.29376L107.181 13.0632C106.737 13.3925 106.645 14.0189 106.974 14.4623C107.303 14.9057 107.93 14.9982 108.373 14.6689L115.599 9.30328ZM0.608026 9.42124C25.6319 20.0205 43.3529 18.376 60.2837 14.9142C77.1926 11.4568 93.0766 6.27237 114.856 9.4897L115.149 7.51117C92.9259 4.22841 76.5863 9.53939 59.8831 12.9547C43.2016 16.3656 25.9217 17.9712 1.38807 7.57963L0.608026 9.42124Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/Arrow3.7bd03d47dd125c7406bc089116a55db8.svg";
export { ForwardRef as ReactComponent };